import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/services/modal/modal.service';
import { UserService } from 'src/app/services/user/user.service';
import { investmentFragmentId } from '../summary/summary.component';

@Component({
  templateUrl: './about-dip.component.html',
  styleUrls: ['./about-dip.component.scss'],
  standalone: false
})
export class AboutDipComponent {
  public investmentFragmentId = investmentFragmentId;

  public dipAdvantages: string[] = [
    'taxAdvantages',
    'wideChoices',
    'longTerm',
    'employerBonus',
    'changeOnFly',
  ];

  public constructor(
    public userService: UserService,
    private router: Router,
    private modalService: ModalService,
  ) { }

  public clickIWantDip(): void {
    if (this.userService.loggedUser?.validContracts.find(contract => contract.dip)) {
      this.router.navigate(['/portfolio/new']);
    } else {
      this.modalService.openConsultModal();
    }
  }
}
